module.exports = __webpack_public_path__ + "assets/priceoff2.jpg?77669d8f25c933f1a6bef93a60350798";